import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Link } from "react-router-dom";
import station from "../../images/Station de pomage/LUD_2024.jpg";
import usineImg from "../../images/Usine de Louveciennes/©Antoine_Meyssonnier-4534.jpg";
import forage from "../../images/forage.jpg";
import cheateu from "../../images/Chateau d'eau.jpg";
import carteImg from "../../images/carte-territoire-ok2 (1).gif";
import { MoveUpRight } from "lucide-react";
const CardContentData = [
  {
    id: "1",
    icon: "1",
    title: "Usine",
    desc: "de production d'eau",
  },

  {
    id: "2",
    icon: "11",
    title: "Forages",
    desc: "de captation de l'eau brute",
  },

  {
    id: "3",
    icon: "105K m³",
    title: "Une capacité",
    desc: "de production journalière",
  },
  {
    id: "3",
    icon: "36",
    title: "Réservoirs",
    desc: "d'eau potable représentant une capacité de stockage de 98600 m³ eniron",
  },
];

const CardTwoContentData = [
  {
    id: "1",
    image: usineImg,
    title: "L'USINE DE LOUVECIENNES",
    link: `/patrimoine/equipements?name=${encodeURIComponent(
      "L'USINE DE LOUVECIENNES"
    )}`,
  },

  {
    id: "2",
    image: forage,
    title: "FORAGES",
    link: `/patrimoine/equipements?name=${encodeURIComponent("FORAGES")}`,
  },
  {
    id: "3",
    image: station,
    title: "STATION DE POMPAGE",
    link: `/patrimoine/equipements?name=${encodeURIComponent(
      "STATION DE POMPAGE"
    )}`,
  },
  {
    id: "4",
    image: cheateu,
    title: "CHÂTEAUX D’EAU ET BASSINS DE STOCKAGE",
    link: `/patrimoine/equipements?name=${encodeURIComponent(
      "CHÂTEAUX D’EAU ET BASSINS DE STOCKAGE"
    )}`,
  },
];

const PatrimoineEquipment = () => {
  return (
    <div>
      <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
        <div>
          <div className="p-3 mt-4 ">
            <p className="text-3xl font-bold text-center ">
              Un patrimoine au fil de l&#39;eau
            </p>
          </div>
          <p className="mt-5 text-justify">
            La politique patrimoniale d’AQUAVESC vise à préserver et mettre en
            valeur les infrastructures historiques de son réseau hydraulique. En
            conciliant respect du passé et innovation, Le syndicat AQUAVESC
            s’engage à garantir la pérennité de ces ouvrages exceptionnels, au
            service du territoire et de ses habitants.
          </p>
          <div id="img">
            <img src={carteImg} alt="" />
          </div>
        </div>
        <div className="flex justify-center">
          <div className="flex flex-col justify-center mt-10 space-y-5 md:space-y-0 md:space-x-5 md:mt-10 md:flex-row">
            {CardContentData.map((item, index) => (
              <Card
                key={item.id}
                className="hover:bg-[#3CC6F7] group w-52 bg-[#f0fafe]"
              >
                <CardHeader>
                  <CardTitle className="flex items-center justify-center">
                    <div className="flex text-sm items-center justify-center w-[60px] h-[60px] text-white mt-2 rounded-full bg-primary group-hover:text-primary group-hover:bg-white">
                      {item.icon}
                    </div>
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex flex-col items-center justify-center">
                  <p className="mt-3 font-bold group-hover:text-white">
                    {item.title.charAt(0).toUpperCase() + item.title.slice(1)}
                  </p>
                  <p className="text-center group-hover:text-white">
                    {item.desc.length > 150
                      ? item.desc.substring(0, 150) + "..."
                      : item.desc}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-[#f0fafe]">
        <div className="container pt-10 mt-10 ">
          <h1 className="text-xl font-bold text-center text-black ">
            Catégories des équipements
          </h1>

          <div className="grid grid-cols-1 gap-4 p-4 mt-4 justify-items-center md:grid-cols-2 md:p-6">
            {CardTwoContentData.map((card, index) => (
              <div className="relative w-full " key={card.id}>
                <div className="w-full mb-44">
                  <div className="relative">
                    <img
                      src={card.image}
                      alt="image"
                      // src={`${uploadUrl}/news/${news.image}`}
                      className={`w-full h-80  rounded-[10px]   `}
                    />
                    <div className=" absolute w-full top-[300px]  p-2 pt-0">
                      <div className="relative w-full bg-white rounded-[10px] shadow-lg  border-[#027BC0] border-b-4">
                        <div className="p-5 text-sm font-bold truncate">
                          {card.title}
                        </div>

                        <div className="w-full pb-5 pl-5 mt-5">
                          <Link to={card.link} className="group">
                            <Button
                              variant="outline"
                              className="rounded-lg group-hover:bg-primary "
                            >
                              <span className="group-hover:text-white">
                                CONSULTER
                              </span>{" "}
                              <MoveUpRight className="w-2 h-2 ml-2 group-hover:text-white" />
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatrimoineEquipment;
